import AuthHelper from '../helpers/auth_helper';
import * as ApplicationHelper from '../helpers/application_helper';
import FootnoteHelper from '../helpers/footnote_helper';

let clearMessagesTimeout;
const MESSAGE_LIFETIME = ApplicationHelper.isSelenium() ? 2000 : 10000;

const MessageDispatcher = {
  clearErrorsAndMessages() {
    this.setStoreVal('errors_and_messages', []);
  },

  async handleRequestError({ error, defaultErrorMessage, override }) {
    if (error && error.response && error.response.status === 401) {
      if (AuthHelper.isShortAuth()) {
        return;
      }
      if (!AuthHelper.isGuestSession()) {
        AuthHelper.deleteSession();
        this.dispatch({ type: 'setRoute', data: '/login' });
      }
      return;
    }
    let errorMessages;
    let fieldErrors;
    if (error && !override) {
      try {
        const text = await error.response.clone().text();
        const parsed = JSON.parse(text);

        if (parsed.messages && parsed.messages.length) {
          errorMessages = parsed.messages;
        }
        if (parsed.fieldErrors && parsed.fieldErrors.length) {
          fieldErrors = parsed.fieldErrors;
        }
        //          airbrake.notify(error);
      } catch (e) {
        //          airbrake.notify(e);
      }
    } else {
      //      airbrake.notify('setError called, but no error message reported');
    }

    const params = new URLSearchParams(window?.location?.search);
    const isMFAPage = window?.location?.pathname.includes('account-details/mfa');
    let redirectUrlParam = '';
    if (params.get('redirectUrl')) {
      redirectUrlParam = `?redirectUrl=${params.get('redirectUrl')}`;
    } else if (!isMFAPage) {
      redirectUrlParam = `?redirectUrl=${window?.location?.pathname}`;
    }

    errorMessages = errorMessages || [defaultErrorMessage];
    if (error && error.response) {
      if (error.response.status >= 500 && error.response.status <= 599) {
        this.dispatch({ type: 'setFailWhaleMessages', data: errorMessages });
        return;
      } else if (error.response.status === 422 && fieldErrors) {
        let codes = fieldErrors.map((e) => e.code);

        if (codes.includes('zip_code_has_no_qualified_products')) {
          this.dispatch({ type: 'setRoute', data: '/product-not-available' });
          return;
        } else if (codes.includes('no_license_for_state')) {
          this.dispatch({ type: 'setRoute', data: '/no-state-license' });
          return;
        }
      } else if (error.response.status === 426) {
        const isSetupError = errorMessages.includes('please setup an mfa device');
        if (isSetupError) {
          this.dispatch({ type: 'upsertView', data: { isRegistering: true } });
        }
        if (!isMFAPage) {
          if (isSetupError) {
            this.dispatch({ type: 'setRoute', data: `/account-details/mfa/setup${redirectUrlParam}` });
            this.dispatch({ type: 'setView', data: { page: 'mfaPage', isRegistering: true } });
            return;
          }
          this.dispatch({ type: 'setRoute', data: `/account-details/mfa/verify${redirectUrlParam}` });
          this.dispatch({
            type: 'setView',
            data: {
              page: 'mfaPage',
              isVerifying: true,
              autoSendSMS: await this.dispatch({ type: 'getIsFreshlyLoggedIn' }),
            },
          });
        }
        return;
      } else if (errorMessages.includes('User training required')) {
        this.dispatch({ type: 'setRoute', data: '/training-required' });
        return;
      }
    }

    this.dispatch({
      type: 'setErrorMessages',
      data: errorMessages,
    });
  },

  scheduleClearErrorsAndMessages() {
    clearTimeout(clearMessagesTimeout);

    clearMessagesTimeout = setTimeout(() => {
      this.dispatch({ type: 'clearErrorsAndMessages' });
    }, MESSAGE_LIFETIME);
  },

  async setFailWhaleMessages(data) {
    this.setStoreVal('failWhaleMessages', data);
    if (!window.location.href.includes('/error?at=')) {
      this.dispatch({ type: 'setRoute', data: `/error?at=${window.location.href}` });
    }
  },

  setErrorMessages(data) {
    // const messages = this.getStoreVal('errors_and_messages');
    let messages = [];
    if (Array.isArray(data)) {
      messages = data;
    } else if (typeof data === 'string') {
      messages = [data];
    }

    this.setStoreVal(
      'errors_and_messages',
      (messages || []).map((message) => {
        return { id: `${Date.now()}-${Math.random()}`, message, type: 'error' };
      })
    );
    this.dispatch({ type: 'scheduleClearErrorsAndMessages' });
  },

  setMessages(data) {
    let messages = [];
    if (Array.isArray(data)) {
      messages = data;
    } else if (typeof data === 'string') {
      messages = [data];
    }

    // const messages = this.getStoreVal('errors_and_messages');
    this.setStoreVal(
      'errors_and_messages',
      (messages || []).map((message) => {
        return { id: `${Date.now()}-${Math.random()}`, message, type: 'info' };
      })
    );
    this.dispatch({ type: 'scheduleClearErrorsAndMessages' });
  },

  registerFootnote({ id, message, variant }) {
    const currentFootnotes = this.getStoreVal('footnotes');
    if (!currentFootnotes.has(id)) {
      currentFootnotes.set(id, { id, message, variant });
      this.setStoreVal('footnotes', FootnoteHelper.updateFootnoteSymbols(currentFootnotes));
    }
  },

  deRegisterFootnote({ id }) {
    const currentFootnotes = this.getStoreVal('footnotes');
    if (currentFootnotes.has(id)) {
      currentFootnotes.delete(id);
      this.setStoreVal('footnotes', FootnoteHelper.updateFootnoteSymbols(currentFootnotes));
    }
  },
};

export default MessageDispatcher;
